import { mapGetters } from "vuex";
import { gotoIndex, doLogin } from "@/libs/tools";
import { formatFormError } from "@/libs/utils";
import Protocol from "../components/protocol";

export default {
  components: {
    protocol: Protocol
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL || "./",
      form: {},
      rules: {},
      errors: {},
      error: "",
      ifProtocol: false,
      protocolName: ""
    };
  },

  computed: {
    ...mapGetters(["isMobile"]),

    isEnterprise() {
      return this.$route.name === "registerEnterprise";
    },

    pageTitle() {
      const type = this.isEnterprise ? "企业" : "个人";
      return `注册${type}用户`;
    },

    registerMode() {
      return this.isEnterprise ? "1" : "7";
    },

    span() {
      return this.isMobile ? 24 : 12;
    }
  },

  methods: {
    /**
     * 验证业务逻辑
     */

    // 验证密码一致
    validSamePassword(rule, value, callback) {
      if (value !== this.form.pwd) {
        callback(new Error());
      } else {
        callback();
      }
    },

    // 验证是否勾选阅读协议
    validProtocolReaded() {
      const valid = this.form.isAgree.length !== 0;
      !valid && this.$message.warning("请勾选协议");

      return valid;
    },

    // 协议
    showProtocol() {
      this.$refs.protocol.show();
    },

    updateProtocol(name) {
      this.protocolName = name;
    },

    agreeProtocol() {
      this.form.isAgree = ["我已阅读并同意"];
    },

    /**
     * 注册业务逻辑
     */

    // base64提交方式，param是form对象（暂时未使用）
    handleFileToBase64(param, cb) {
      let reader = new FileReader();
      let index = 0;
      const fileKeys = ["socialCreditPic", "contractImg", "signPic"];

      reader.onload = e => {
        const key = fileKeys[index];
        param[key] = e.target.result;

        if (index < fileKeys.length - 1) {
          index += 1;
          reader.readAsDataURL(param[fileKeys[index]]);
        } else {
          // 执行真正的提交操作
          cb && typeof cb === "function" && cb();
        }
      };

      // 触发
      reader.readAsDataURL(param[fileKeys[0]]);
    },

    // 组装提交数据
    uploadSubmitParam() {
      let param = { ...this.form };
      delete param["isAgree"];

      const formData = new FormData();
      Object.keys(param).forEach(k => formData.append(k, param[k]));

      return formData;
    },

    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        if (!this.validProtocolReaded()) return;

        const options = {
          headers: {
            "Content-Type": "multipart/form-data",
            timeout: 90000
          },
          data: {
            type: "default" // 数据无需转成string
          }
        };
        const param = this.uploadSubmitParam();
        this.loading = true;

        this.$request.account_register(param, options).then(res => {
          const { code = -1, msg = {} } = res;

          if (code !== 0) {
            this.loading = false;
            this.handleError(msg);
            return;
          }

          this.error = "";
          this.$message.success("注册成功");

          doLogin(
            {
              userName: this.form.authPersonMobile,
              pwd: this.form.pwd
            },
            res => {
              this.loading = false;
              if (res.code !== 0) {
                // this.$message.error("请前往登录");
                gotoIndex();
              }
            }
          );
        });
      });
    },

    // 处理接口报错信息
    handleError(error) {
      this.error = error["remote_error"] || "";
      !this.error && formatFormError(this, this.errors, error);
    },

    /**
     * 路由跳转
     */

    goIndex() {
      gotoIndex();
    },

    goLogin() {
      this.$router.push({ name: "login" });
    },

    goback() {
      this.$router.push({ name: "register" });
    }
  }
};
